import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivityLeaderboardComponent } from './activity-leaderboard.component';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyTableModule } from '@vendasta/galaxy/table';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { MatSortModule } from '@angular/material/sort';
import { TranslationModule } from '../../i18n';
import { ActivityLeaderboardDatasource } from './activity-leaderboard.datasource';

@NgModule({
  exports: [ActivityLeaderboardComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    TranslationModule,
    GalaxyTableModule,
    MatTableModule,
    MatSelectModule,
    MatSortModule,
    GalaxyFormFieldModule,
    GalaxyAvatarModule,
    ActivityLeaderboardComponent,
  ],
  providers: [ActivityLeaderboardDatasource],
})
export class ActivityLeaderboardModule {}
